import { useEffect, useMemo, useState } from 'react';
import { SONG_SLOT_MAX_LENGTH } from '@soundxyz/utils/const';
import { canOverwriteSlot } from '@components/modals/Comment/SetTimeSlot';
import { gql, SelectReleaseSongSlotDocument, useQuery } from '@graphql/reactQuery';
import type { UserNft } from './useMultipleNftsForRelease';

/*#__PURE__*/ gql(/* GraphQL */ `
  query SelectReleaseSongSlot($releaseId: UUID!) {
    release(id: $releaseId) {
      id
      claimedSongSlots
      track {
        id
      }
    }
  }
`);

export const useSongSlots = ({
  releaseId,
  selectedNft,
}: {
  releaseId: string;
  selectedNft?: UserNft;
}) => {
  const [songSlot, setSongSlot] = useState<number | null>(selectedNft?.songSlot ?? null);

  useEffect(() => {
    if (selectedNft?.songSlot) {
      setSongSlot(selectedNft.songSlot);
    }
  }, [selectedNft]);

  const { data: releaseData } = useQuery(SelectReleaseSongSlotDocument, {
    variables: {
      releaseId,
    },
    staleTime: 0,
  });

  const release = releaseData?.data.release;
  const releaseTrack = release?.track;

  const claimedSongSlots = useMemo(() => {
    return new Set(release?.claimedSongSlots || []);
  }, [release?.claimedSongSlots]);

  const canOverwrite = canOverwriteSlot({
    claimedSlots: claimedSongSlots.size,
    totalSlots: SONG_SLOT_MAX_LENGTH,
  });

  return { releaseTrack, claimedSongSlots, setSongSlot, songSlot, canOverwriteSlot: canOverwrite };
};
